module.exports = __webpack_public_path__ + "img/new-people-customer-using-app.e83feb1f.png";